// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tryAndPricing__HomeUpdated-module--wMqj7 {
    padding: var(--space-md) var(--space-md) var(--space-3xl);
}

.tryAndPricingInner__HomeUpdated-module--Cl80c {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(440px, 100%), 1fr));
    gap: var(--space-sm);
    align-items: stretch;
}

/* Confirmation after the registration page sends a new customer back here with ?registered=true. */
.registered__HomeUpdated-module--mirlV {
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--space-md) var(--space-md) 0;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/HomeUpdated.module.css"],"names":[],"mappings":"AAAA;IACI,yDAAyD;AAC7D;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sEAAsE;IACtE,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA,mGAAmG;AACnG;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C","sourcesContent":[".tryAndPricing {\n    padding: var(--space-md) var(--space-md) var(--space-3xl);\n}\n\n.tryAndPricingInner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(440px, 100%), 1fr));\n    gap: var(--space-sm);\n    align-items: stretch;\n}\n\n/* Confirmation after the registration page sends a new customer back here with ?registered=true. */\n.registered {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: var(--space-md) var(--space-md) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tryAndPricing": `tryAndPricing__HomeUpdated-module--wMqj7`,
	"tryAndPricingInner": `tryAndPricingInner__HomeUpdated-module--Cl80c`,
	"registered": `registered__HomeUpdated-module--mirlV`
};
export default ___CSS_LOADER_EXPORT___;
